"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = require("./Card.styles");

var _excluded = ["children"];

var Card = function Card(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Card.StyledCard, rest, children);
};

Card.defaultProps = {
  shadow: true
};
Card.propTypes = {
  children: _propTypes["default"].node,
  shadow: _propTypes["default"].bool,
  className: _propTypes["default"].string,

  /**
   * accept number between 0 to 7 and return space in [0,4,8,12,16,20,24,28]px respectively
   */
  spaceAround: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6, 7])
};
var _default = Card;
exports["default"] = _default;